const isBrowser = typeof document !== "undefined";

export { isBrowser };
